module.exports = __webpack_public_path__ + "img/bussiness-details.4f0bc9ee.svg";